/**
 * DI-3-F — the N2 start rule and "does the upload need this tab", pure (the
 * runner store and the upload driver both read them).
 */
import { reached } from "./phases.js";
import type { RunnerSet } from "./runnerStore.js";
import { uploadFinished } from "../upload/state.js";

/**
 * May the set's upload run now (N2)? "now": once its round trip is `synced`
 * — never before; "after": once Approve answered `approved_pending_upload`;
 * a partner set (`uploadChoice === null`) never.
 */
export function uploadStartable(s: RunnerSet): boolean {
  const u = s.upload;
  if (!u || s.uploadChoice === null || !s.created) return false;
  if (uploadFinished(u)) return false;
  if (!reached(s.phase, "synced")) return false;
  // DI-3-G — an add waits for `metadata-complete`'s answer: `unchanged` ends
  // its upload without a PUT (the runner marks it present), `enqueued` lets
  // the new files go
  if (s.boundTo && !reached(s.phase, "running")) return false;
  if (s.uploadChoice === "after" && !u.approvedAt) return false;
  return true;
}

/** Does the set hold upload work that closing the tab would pause? */
export function uploadPending(s: RunnerSet): boolean {
  if (!uploadStartable(s)) return false;
  const p = s.upload?.phase;
  return p === "queued" || p === "uploading" || p === "committing";
}
